export function parseChatCommands(text) {
    const raw = String(text || '')
    const commands = []
    const pattern = /add_to_cart:([A-Za-z0-9][A-Za-z0-9._-]{0,31}):(sample|\d{1,6})/gi

    for (const match of raw.matchAll(pattern)) {
        const sample = String(match[2]).toLowerCase() === 'sample'
        commands.push({
            sku: String(match[1]).toUpperCase(),
            sample,
            qty: sample ? 1 : Math.max(1, parseInt(match[2], 10) || 1),
        })
    }

    const visible = raw
        .replace(/add_to_cart:([A-Za-z0-9][A-Za-z0-9._-]{0,31}):(sample|\d{1,6})/gi, '')
        .replace(/[ \t]+/g, ' ')
        .replace(/\n{3,}/g, '\n\n')
        .trim()

    return {text: visible, commands}
}

export function formatCartCommand(command) {
    if (!command?.sku) {
        return ''
    }

    return command.sample
        ? `${command.sku} sample`
        : `${command.sku} × ${command.qty}`
}
